export const Colors = {
    dark: "#343A40",
    mintWhite: "#F4F7F5",
    gray: "#9FA3A4",
}